import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export  function Banner() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClickContact = (e) => {
        e.preventDefault();
        navigate('/contact');
      }

    return (
        <>
            <div className="container-blue reveal">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                    </div>
                    <div className="col-md-9">
                        <h1 className="text-right mb-6 he">{t("solutions.banner.title")}</h1>
                    </div>
                </div>
                <div className="separar"></div>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-right">{t("solutions.banner.subtitle")}</h4>
                        <div className="separar"></div>
                        <a href="javascript:void();" onClick={(e) => handleClickContact(e)} className="btn btn-primary float-right">{t("index.banner.button")}</a>
                    </div>
                </div>
            </div>
            </div>
        </>
        
        )
}

export default Banner